import React, { useContext } from 'react';
import { bool, number } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Col, Row, Placeholder, Heading } from '@thd-olt-component-react/core-ui';

const FBTPlaceholder = ({ itemsCount, hideTitle, itemHeight }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const numOfLinesTxtPlaceholders = isMobile ? 13 : 13;
  let numOfPlaceholders = isMobile ? 2 : 6;
  let placeholderHeight = isMobile ? '260px' : '295px';

  if (itemsCount) {
    numOfPlaceholders = itemsCount;
  }
  if (itemHeight) {
    placeholderHeight = (itemHeight - 170) + 'px';
  }
  return (
    <Row>
      {!hideTitle && <Heading title="Loading Recommendations" underline />}
      <Row key="placeholder-row">
        {[...Array(numOfPlaceholders)].map((__, ind) => (
          <Col fallback={isMobile ? '6' : '2'} xs="2" key={`pod-placeholder-${ind}`}>
            <Placeholder type="rect" height={placeholderHeight} />
            {new Array(numOfLinesTxtPlaceholders).fill('').map((___, i) => (
              <Placeholder type="text" key={`txt-row-${i}`} />
            ))}
          </Col>
        ))}
      </Row>
    </Row>
  );
};

FBTPlaceholder.propTypes = {
  hideTitle: bool,
  itemsCount: number,
  itemHeight: number
};

FBTPlaceholder.defaultProps = {
  hideTitle: false,
  itemsCount: null,
  itemHeight: null
};

export { FBTPlaceholder };
